import guidGenerator from '../../utils/guidGenerator'

export default {
    state: {
        notyList: []
    },
    mutations: {
        addNoty(state, noty) {
            noty.id = noty.id || guidGenerator.guid();
            state.notyList.push(noty);
        },
        addError(state, text) {
            var id = guidGenerator.guid();
            state.notyList.push({
                id: id,
                type: "error",
                text: text
            });
        },
        addValidationError(state, data) {
            const id = data.name.replace(" ", "_") + "_validation";
            let noty = state.notyList.find(x => x.id == id);
            
            if(noty && data.message){
                noty.text = data.message;
            } else if (!data.message){
                let filtered = state.notyList.filter(x => x.id !== id);
                state.notyList = filtered;
            } else {
                state.notyList.push({
                    id: id,
                    type: "error",
                    text: data.message
                });
            }
        },
        removeNoty(state, guid) {
            let filtered = state.notyList.filter(x => x.id !== guid);
            state.notyList = filtered;
        },
        clearAllNoties: state => state.notyList = []
    },
    getters: {
        notiesToShow: state => state.notyList.slice(0, 3),
        notyExists: state => id => state.notyList.some(item => item.id == id)
    }
}